import React from 'react';
import Tag, { TagProps } from '../atoms/Tag';
import { FLAG_MAP } from '../../../utils/flags';

export type TagPickerProps = {
  categoryKey: TagProps['category'];
  tags: { id: string; name: string }[];
  selected: string[];
  onToggle: (tagId: string) => void;
  size?: 'sm' | 'md';
};

const REGION_NAMES = [
  'south_american',
  'african',
  'middle_eastern',
  'mediterranean',
  'balkan',
];

export function TagPicker({
  categoryKey,
  tags,
  selected,
  onToggle,
  size = 'sm',
}: TagPickerProps) {
  let ordered = tags;

  if (categoryKey === 'cuisine') {
    const flags  = tags.filter((t) => FLAG_MAP.hasOwnProperty(t.name));
    const regions = tags.filter((t) => REGION_NAMES.includes(t.name));
    ordered = [...flags, ...regions];
  }

  return (
    <div className="flex gap-2 overflow-x-auto whitespace-nowrap py-1 px-1 hide-scrollbar">
      {ordered.map((t) => (
        <Tag
          key={t.id}
          name={t.name}
          category={categoryKey}
          variant="pill"
          size={size}
          isSelected={selected.includes(t.id)}
          onClick={() => onToggle(t.id)}
        />
      ))}
    </div>
  );
}
